import React from 'react';

const SurveyVehicleChart = ({ CurrentTheme, VehicleChart, hideVehicleChart }) => {
    return (
        <div id="displayVehicleModel" className="modal" style={{ display: "block", paddingTop: "60px" }}>
            <div className="modal-content">
                <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding: "5px" }}>Vehicle Chart</span>
                    <span className="close" onClick={hideVehicleChart}>&times;</span>
                </div>
                <table className="table table-striped align-center">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Size</th>
                            <th>Capacity</th>
                            <th>Max Weight</th>
                            <th>CFT</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {VehicleChart.length > 0 && VehicleChart.map((goods, index) => (
                            <tr key={index}>
                                <td>{goods.Name}</td>
                                <td>{goods.Size}</td>
                                <td>{goods.HHGCapacity}</td>
                                <td>{goods.MaxWeight}</td>
                                <td>{goods.MaxCFT}</td>
                                <td>{goods.TypeOfLoad}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SurveyVehicleChart;